export default "__VITE_ASSET__7p2EHXtq__"